import { CurrencyEnum, LocaleEnum, units } from '@systemeio/ui'
import { ChartOptions } from 'chart.js'
import { currencyFormat } from 'shared/utils/currency-format'
import { getCssRgbValue } from 'shared/utils/get-css-rgb-value'

export const getAffiliateChartOptions = (
  showGrid: boolean,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
): ChartOptions<'bar'> => {
  return {
    maintainAspectRatio: false,
    responsive: true,
    font: { family: 'Averta' },
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      y: {
        display: showGrid,
        border: { dash: [12, 12], display: false },
        grid: {
          color: function (context) {
            if (context.tick.value === 0) {
              return 'rgba(0, 0, 0, 0)'
            }
            return getCssRgbValue('--text-secondary', 0.3)
          },
          drawTicks: false,
        },
        ticks: {
          color: getCssRgbValue('--text-primary'),
          callback: function (value) {
            if (!selectedCurrency) return value
            return currencyFormat(units(value), selectedCurrency, locale, true)
          },
        },
      },
      x: { grid: { display: false }, ticks: { color: getCssRgbValue('--text-primary') } },
    },
  }
}
